import useBreakpoint from '@common/utils/useBreakpoint';
import analytics from '@utils/analytics';
import React from 'react';
import { useTranslation } from 'react-i18next';
const SizeGuideButton = (props) => {
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    return (React.createElement("button", { type: "button", className: "button button--link findmysize-cta", onClick: () => {
            props.setSizeguideOpen(true);
            (props === null || props === void 0 ? void 0 : props.pid) && analytics.sizeGuide(props.pid);
        }, "aria-haspopup": props.withAria ? 'dialog' : undefined },
        React.createElement("span", { className: "btn-label-find-size" },
            t('sizeguide.findmysizecta'),
            React.createElement("i", { className: "icon--new-ruler" }))));
};
export default SizeGuideButton;
